/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  FileSelector,
  Modal,
  Heading,
  SvgIcon,
  SelectWithData,
  Select
} from '../'

import { FileTypeSelect } from './FileTypeSelect'


export class BulkFileUploader extends React.Component {
  static propTypes = {
    heading: PropTypes.string,
    uploadButtonText: PropTypes.string,
    onCancel: PropTypes.func,
    fileTypes: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      lable: PropTypes.string.isRequired
    })),
    fileType: PropTypes.string,
    relationships: PropTypes.arrayOf(PropTypes.array),
    className: PropTypes.string
  }

  state = {
    fileType: this.props.fileType,
    filesUploaded: 0,
    error: false,
    fileTypeLanguage: null
  }

  uploadFile = (file, fileType) => {
    let body = new FormData()
    body.append('filetype', fileType)
    body.append('file', file)
    body.append(
      'relationships',
      this.props.relationships
        ? JSON.stringify(this.props.relationships)
        :"[]"
    )

    fetch(`${process.env.REACT_APP_API_ROOT}/v1/file/`, {
      method: 'post',
      headers: {
        "Authorization": "Token " + localStorage.getItem('token') || null
      },
      body: body
    })
    .then((response) => {
      if (response.ok) {  // covers 200-range of http responses
        console.log("Upload successful.")
        this.setState((prevState) => (
          {
            filesUploaded: prevState.filesUploaded + 1
          }
        ))
      } else {
        console.log(`Upload failed.  HTTP: ${response.status} - ${response.statusText}`)
        this.setState({ error: true })
      }
    })
    .catch((error) => {
      console.log('Upload failed', error)
      this.setState({ error: true })
    })
  }

  uploadFiles = (filesObj, fileType) => {
    this.setState({ filesToUpload: Object.keys(filesObj).length })

    for (let file of Object.values(filesObj)) {
      this.uploadFile(file, fileType)
    }
  }

  handleSelection = (e) => {
    let field = e.target.id
    this.setState({ [field]: e.target.value })
  }

  render() {
    return (
      <div className={this.props.className ? this.props.className : ''}>
        {this.state.filesToUpload > 0 &&
          <Modal
            body={
              <Heading className="slds-text-align_center slds-m-top_medium">
                {this.state.error
                  ? <div>
                      <SvgIcon
                        variant="utility"
                        symbol="warning"
                        size="large"
                        colour="error"
                        className="slds-align_absolute-center"
                      />
                      <Heading className="slds-p-top_medium u-no-margin__b">
                        Sorry, the file(s) upload failed.<br />
                        Please try again and please contact us if problem persists.
                      </Heading>
                    </div>
                  : this.state.filesUploaded === this.state.filesToUpload
                    ? "Uploading complete."
                    : `Uploading file ${this.state.filesUploaded + 1} of ${this.state.filesToUpload}...`
                }
              </Heading>
            }
            footer={
              <div className="slds-text-align_center">
                <Button
                  disabled={!this.state.error && (this.state.filesToUpload > this.state.filesUploaded)}
                  onClick={() => (
                    this.setState({
                      filesToUpload: 0,
                      filesUploaded: 0,
                      error: false,
                      fileType: null
                    }, this.props.onSuccess)
                  )}>
                  OK
                </Button>
              </div>
            }
          />
        }
        {this.props.heading &&
          <Heading>
            {this.props.heading}
          </Heading>
        }
        {this.props.fileTypes
          ? <Select
              id='fileType'
              label='Select file type'
              placeholder='Choose'
              value={this.state.fileType}
              options={this.props.fileTypes}
              onChange={this.handleSelection}
              className='slds-size_1-of-3'
            />
          : this.props.fileType
            ? null
            : <div className='slds-grid'>
                <SelectWithData
                  id='fileTypeLanguage'
                  label='Select language'
                  forField='FileTypeLanguage'
                  value={this.state.fileTypeLanguage}
                  onChange={this.handleSelection}
                  placeholder='Choose'
                />
                <FileTypeSelect
                  fileType={this.state.fileType}
                  language={this.state.fileTypeLanguage}
                  onSelect={this.handleSelection}
                  className='slds-m-left_medium'
                />
              </div>
        }
        <div className='slds-m-top_large'>
          Choose files
          <FileSelector
            dropzone={true}
            integrated={true}
            buttonLabel={this.props.uploadButtonText}
            disabled={!this.state.fileType}
            cancelButton={true}
            reset={this.state.fileType === null}
            onCancel={this.props.onCancel}
            onClick={filesObj => this.uploadFiles(filesObj, this.state.fileType)}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/bulk-file-uploader/index.js